import { handleRequest } from "../utilities/requestHandler";


const loginService = async (data) => {
    try {
        const response = await handleRequest("post", "/auth/login", data);
        return response;
    } catch (error) {
        
        return error.response.data;
    }
};

export const logoutService = async () => {
    try {
        await handleRequest("post", "/auth/logout");
        return { status: true };
    } catch (error) {
        
        // Even if logout API fails, proceed to clear local session client-side
        return { status: false, error: error?.response?.data || error.message };
    }
};

export default loginService;
